



import { Link, useParams } from "react-router-dom";
import Header from "../../component/Header.jsx";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import GeneralTable from "../../component/Tables/GeneralTable.jsx";
import ScheduleTable from "../../component/Tables/ScheduleTable.jsx";
import { BiMessageAltAdd } from "react-icons/bi";
import InterviewTable from "../../component/Tables/InterviewedTable.jsx";
import HiredTable from "../../component/Tables/HiredTable.jsx";
import OfferTable from "../../component/Tables/OfferTable.jsx";
import Skeleton from "../../component/Skeleton.jsx";
import { useFetchData } from "../../hooks/useFtechData.js";
import { APPLICATION_API } from "../../resources/resource.js";

const HistoryList = ({ applicationId, onViewMessage }) => {
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchHistory = async () => {
      try {
        const res = await fetch(`${process.env.REACT_APP_API_URL}application/invitation-history/${applicationId}`);
        const data = await res.json();
        setHistory(data.data || []);
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };
    fetchHistory();
  }, [applicationId]);

  if (loading) return <p>Loading history...</p>;
  if (history.length === 0) return <p className="text-gray-500">No invitations sent yet.</p>;

  const typeLabels = {
    shortlist_invite: "Shortlist Notification",
    interview_invite: "Interview Invitation",
    offer_invite: "Job Offer"
  };

  const statusColors = {
    accepted: "bg-green-100 text-green-800",
    rejected: "bg-red-100 text-red-800",
    pending: "bg-yellow-100 text-yellow-800",
    expired: "bg-gray-100 text-gray-800"
  };

  return (
    <div className="space-y-4">
      {history.map((inv) => (
        <div
          key={inv._id}
          className="border rounded-lg p-5 hover:shadow-md transition-shadow cursor-pointer"
          onClick={() => onViewMessage(inv)}
        >
          <div className="flex justify-between items-start">
            <div>
              <p className="font-semibold text-lg">
                {typeLabels[inv.actionType] || inv.actionType}
              </p>
              <p className="text-sm text-gray-600 mt-1">
                Sent: {new Date(inv.createdAt).toLocaleDateString()} at {new Date(inv.createdAt).toLocaleTimeString([], {hour: '2-digit', minute: '2-digit'})}
              </p>
              {inv.respondedAt && (
                <p className="text-sm text-gray-500">
                  Responded: {new Date(inv.respondedAt).toLocaleString()}
                </p>
              )}
            </div>
            <span className={`px-3 py-1 rounded-full text-xs font-medium ${statusColors[inv.status] || 'bg-blue-100 text-blue-800'}`}>
              {inv.status.charAt(0).toUpperCase() + inv.status.slice(1)}
            </span>
          </div>
          {inv.message && (
            <p className="text-gray-700 mt-3 line-clamp-2">
              {inv.message.replace(/<[^>]*>/g, '').substring(0, 120)}...
            </p>
          )}
        </div>
      ))}
    </div>
  );
};

function ApplicantList() {
  const { jobId,  jobSeekerId } = useParams();
  const [allApplicant, setAllApplicant] = useState([]);
  const [interviewedApplicant, setInterviewedApplicant] = useState([]);
  const [rejectedApplicant, setRejectedApplicant] = useState([]);
  const [hiredApplicant, setHiredApplicant] = useState([]);
  const [shortlistedApplicant, setShortlistedApplicant] = useState([]);
  const [scheduledApplicant, setScheduledApplicant] = useState([]);
  const [offerApplicant, setOfferApplicant] = useState([]);
  const [currentList, setCurrentList] = useState([]);
  const [activeSelection, setActiveSelection] = useState("Applied");
  const [table, setTable] = useState("General");
  const currentUser = useSelector((state) => state.user);
  const [position, setPosition] = useState("");
  const [loading, setLoading] = useState(false);
  const [selectedMessage, setSelectedMessage] = useState(null);
  const navigate = useNavigate();

  // Invitation Modal states
  const [showInviteModal, setShowInviteModal] = useState(false);
  const [selectedApplicant, setSelectedApplicant] = useState(null);
  const [inviteMessage, setInviteMessage] = useState("");
  const [inviteType, setInviteType] = useState("shortlist");

  // History Modal states
  const [showHistoryModal, setShowHistoryModal] = useState(false);
  const [selectedHistoryApp, setSelectedHistoryApp] = useState(null);
  const isJobSeekerMode = !!jobSeekerId;

    const apiUrl = isJobSeekerMode 
      ? `${APPLICATION_API}/getApplicationsByJobSeeker/${jobSeekerId}`
      : `${APPLICATION_API}/getApplicationByJobId/${jobId}`;
  

  const {
    data: applicationDetails,
    refetch,
    loading: loadingApplication,
    error,
  } = useFetchData(APPLICATION_API + `/getApplicationByJobId/${jobId}`);

  useEffect(() => {
    if (!applicationDetails) return;
    setLoading(true);
    const getApplicantList = async () => {
      try {
        setAllApplicant(applicationDetails);
        setCurrentList(applicationDetails);
        setPosition(applicationDetails[0]?.position || "");
        setInterviewedApplicant(
          applicationDetails.filter(
            (eachApplicant) => eachApplicant.status === "Interviewed"
          )
        );
        setRejectedApplicant(
          applicationDetails.filter(
            (eachApplicant) => eachApplicant.status === "Rejected"
          )
        );
        setHiredApplicant(
          applicationDetails.filter(
            (eachApplicant) => eachApplicant.status === "Hired"
          )
        );
        setShortlistedApplicant(
          applicationDetails.filter(
            (eachApplicant) => eachApplicant.status === "Shortlisted"
          )
        );
        setScheduledApplicant(
          applicationDetails.filter(
            (eachApplicant) => eachApplicant.status === "Scheduled"
          )
        );
        setOfferApplicant(
          applicationDetails.filter(
            (eachApplicant) => eachApplicant.status === "Offer"
          )
        );
      } catch (error) {
        console.log({ err: error });
      } finally {
        setLoading(false);
      }
    };
    getApplicantList();
  }, [jobId, applicationDetails]);

  const handleFilter = (newArray, table) => {
    setTable(table);
    const selectedElement = table.split(" ")[1];
    const statusMap = {
      Applied: allApplicant,
      Rejected: rejectedApplicant,
      Shortlisted: shortlistedApplicant,
      Scheduled: scheduledApplicant,
      Hired: hiredApplicant,
      Offer: offerApplicant,
      Interviewed: interviewedApplicant,
    };
    setCurrentList(statusMap[selectedElement] || []);
    setActiveSelection(selectedElement);
  };

  const handleNavigation = () => {
    navigate(`/${jobId}/applicantResponse`);
  };

  const handleInterview = (e) => {
    const interviewLength = scheduledApplicant[0]?.interviews?.length || 0;
    if (interviewLength === 0) return;

    const interviewId = scheduledApplicant[0].interviews[interviewLength - 1]._id;
    if (e.target.innerHTML === "Start") {
      navigate(`/interview/start/${interviewId}`);
    }
  };

  // Open invitation modal with prefilled message
  const openInviteModal = (applicant, type) => {
    setSelectedApplicant(applicant);
    setInviteType(type);

    const seeker = applicant.applicant?.[0] || {};
    const name = seeker.firstName || "Candidate";

    const defaultMessages = {
      shortlist: `Dear ${name},\n\nWe are pleased to inform you that your application has been shortlisted...`,
      interview: `Congratulations ${name}!\n\nWe would like to invite you for an interview...`,
      offer: `Dear ${name},\n\nWe are pleased to offer you the position...`,
    };

    setInviteMessage(defaultMessages[type] || "");
    setShowInviteModal(true);
  };

  const handleSendInvitation = async () => {
    if (!selectedApplicant) return;

    setLoading(true);

    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}application/send-invitation`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          // Add authorization header if needed: Authorization: `Bearer ${token}`
        },
        body: JSON.stringify({
          applicationId: selectedApplicant._id,
          message: inviteMessage,
          inviteType,
        }),
      });

      if (!response.ok) {
        const err = await response.json();
        throw new Error(err.message || "Failed to send invitation");
      }

      alert("Invitation sent successfully!");
      setShowInviteModal(false);
      setInviteMessage("");
      refetch();
    } catch (err) {
      console.error(err);
      alert("Failed to send invitation: " + err.message);
    } finally {
      setLoading(false);
    }
  };

  // Open history modal (you'll need real data later)
  const handleViewHistory = (application) => {
    setSelectedHistoryApp(application);
    setShowHistoryModal(true);
    // Later: fetch real history from backend
  };

  // Helper to get applicant name safely
  const getSeekerName = (application) => {
    const seeker = application?.applicant?.[0];
    return seeker
      ? `${seeker.firstName || ""} ${seeker.lastName || ""}`.trim() || "Unnamed"
      : "—";
  };

  return (
    <div className="min-h-screen pt-16 sm:pt-20 bg-gray-100 flex flex-col">
      <Header />
  <div className="bg-white shadow-sm border-b px-6 py-4">
        <h1 className="text-2xl font-bold text-gray-800">
          {isJobSeekerMode 
            ? "Job Seeker Applications History" 
            : `Applicants for ${applicationDetails?.[0]?.position || "Job"}`}
        </h1>
        {isJobSeekerMode && (
          <p className="text-gray-600">All applications submitted by this candidate</p>
        )}
      </div>
      {/* === Invitation Modal === */}
      {showInviteModal && selectedApplicant && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-lg max-w-2xl w-full max-h-[90vh] overflow-y-auto">
            <div className="p-6 border-b">
              <h2 className="text-xl font-semibold">
                {inviteType === "shortlist" && "Shortlist Invitation"}
                {inviteType === "interview" && "Interview Invitation"}
                {inviteType === "offer" && "Job Offer"}
              </h2>
              <p className="text-gray-600 mt-1">
                To: {getSeekerName(selectedApplicant)} ({selectedApplicant.applicant?.[0]?.email || "—"})
              </p>
            </div>

            <div className="p-6 space-y-6">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Invitation Message
                </label>
                <textarea
                  className="w-full h-40 p-3 border rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500"
                  value={inviteMessage}
                  onChange={(e) => setInviteMessage(e.target.value)}
                  placeholder="Write your message here..."
                />
              </div>

              <div className="bg-gray-50 p-4 rounded-lg">
                <p className="text-sm text-gray-600">The email will automatically include:</p>
                <ul className="mt-2 space-y-1 text-sm text-gray-600 list-disc pl-5">
                  <li>Accept / Decline buttons</li>
                  <li>Your company name</li>
                  <li>Job position: {selectedApplicant.position}</li>
                  <li>Expiration: 7 days</li>
                </ul>
              </div>
            </div>

            <div className="p-6 border-t flex justify-end gap-4">
              <button
                onClick={() => {
                  setShowInviteModal(false);
                  setInviteMessage("");
                }}
                className="px-5 py-2 border rounded-lg hover:bg-gray-50"
              >
                Cancel
              </button>
              <button
                onClick={handleSendInvitation}
                disabled={loading || !inviteMessage.trim()}
                className="px-6 py-2 bg-orange-600 text-white rounded-lg hover:bg-orange-700 disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-2"
              >
                {loading ? "Sending..." : "Send Invitation"}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* === History Modal (placeholder - extend later) === */}
  {/* === REAL HISTORY MODAL === */}
{showHistoryModal && selectedHistoryApp && (
  <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
    <div className="bg-white rounded-lg max-w-4xl w-full max-h-[90vh] overflow-y-auto">
      <div className="p-6 border-b sticky top-0 bg-white z-10">
        <h2 className="text-2xl font-bold">Invitation History</h2>
        <p className="text-gray-600 mt-1">
          {getSeekerName(selectedHistoryApp)} - {selectedHistoryApp.position}
        </p>
      </div>

      <div className="p-6">
        <HistoryList applicationId={selectedHistoryApp._id} onViewMessage={setSelectedMessage} />
      </div>

      <div className="p-6 border-t flex justify-end">
        <button
          onClick={() => {
            setShowHistoryModal(false);
            setSelectedMessage(null);
          }}
          className="px-6 py-3 bg-gray-600 text-white rounded-lg hover:bg-gray-700"
        >
          Close
        </button>
      </div>
    </div>
  </div>
)}

{/* Message Preview Modal */}
{selectedMessage && (
  <div className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-50 p-4">
    <div className="bg-white rounded-lg max-w-3xl w-full max-h-[90vh] overflow-y-auto">
      <div className="p-6 border-b">
        <h3 className="text-xl font-bold">Email Preview</h3>
        <p className="text-sm text-gray-500">Sent on: {new Date(selectedMessage.createdAt).toLocaleString()}</p>
      </div>
      <div className="p-6 bg-gray-50">
        <div dangerouslySetInnerHTML={{ __html: selectedMessage.message }} />
      </div>
      <div className="p-6 border-t">
        <button
          onClick={() => setSelectedMessage(null)}
          className="px-6 py-3 bg-orange-600 text-white rounded-lg hover:bg-orange-700"
        >
          Close
        </button>
      </div>
    </div>
  </div>
)}
      {loading && <Skeleton />}

      {applicationDetails?.length > 0 ? (
        <div className="flex-1 container mx-auto px-4 py-6 sm:px-6 lg:px-8">
          <div className="bg-white rounded-lg shadow-sm border border-gray-200">
            {/* Tabs Navigation */}
            <nav className="border-b border-gray-200 px-4">
              <ul className="flex flex-wrap gap-2 py-4 overflow-x-auto">
                {[
                  { label: "Applied", count: allApplicant.length, value: "General Applied" },
                  { label: "Rejected", count: rejectedApplicant.length, value: "General Rejected" },
                  { label: "Shortlisted", count: shortlistedApplicant.length, value: "General Shortlisted" },
                  { label: "Scheduled", count: scheduledApplicant.length, value: "Scheduled Scheduled" },
                  { label: "Interviewed", count: interviewedApplicant.length, value: "General Interviewed" },
                  { label: "Offer", count: offerApplicant.length, value: "General Offer" },
                  { label: "Hired", count: hiredApplicant.length, value: "General Hired" },
                ].map((tab) => (
                  <li key={tab.label}>
                    <button
                      onClick={() => handleFilter([], tab.value)}
                      className={`px-4 py-2 rounded-md text-sm font-medium transition-colors duration-200 flex items-center gap-2 ${
                        activeSelection === tab.label
                          ? "bg-orange-500 text-white"
                          : "text-gray-700 hover:bg-gray-100"
                      }`}
                    >
                      <span className="bg-gray-200 text-gray-700 rounded-full px-2 py-1 text-xs">
                        {tab.count}
                      </span>
                      <span>{tab.label}</span>
                    </button>
                  </li>
                ))}
              </ul>
            </nav>

            {/* Content Area */}
            <div className="p-6 relative">
              {/* Floating Action Button */}
              <button
                onClick={handleNavigation}
                className="fixed bottom-10 right-10 bg-orange-500 text-white p-3 rounded-full shadow-lg hover:bg-orange-600 transition-colors duration-200"
                title="Add Response"
              >
                <BiMessageAltAdd className="w-6 h-6" />
              </button>

              {/* Tables */}
              <div className="overflow-x-auto">
                {activeSelection === "Scheduled" ? (
                  <ScheduleTable
                    data={scheduledApplicant}
                    title="Interviews"
                    handleInterview={handleInterview}
                    refetch={refetch}
                    onInvite={(app) => openInviteModal(app, "interview")}
                    onHistory={handleViewHistory}
                  />
                ) : activeSelection === "Interviewed" ? (
                  <InterviewTable
                    data={interviewedApplicant}
                    onHistory={handleViewHistory}
                  />
                ) : activeSelection === "Hired" ? (
                  <HiredTable
                    currentList={hiredApplicant}
                    data={allApplicant}
                    onHistory={handleViewHistory}
                  />
                ) : activeSelection === "Offer" ? (
                  <OfferTable
                    currentList={offerApplicant}
                    onHistory={handleViewHistory}
                  />
                ) : (
                  <GeneralTable
                    currentList={currentList}
                    handleNavigation={handleNavigation}
                    data={allApplicant}
                    onInvite={openInviteModal}
                    onHistory={handleViewHistory}
                  />
                )}
              </div>

              {/* Back Button */}
              <Link
                to={`/employer/${currentUser?.currentUser?._id}`}
                className="inline-block mt-6 bg-gray-500 text-white px-6 py-2 rounded-md hover:bg-gray-600 transition-colors duration-200"
              >
                Back
              </Link>
            </div>
          </div>
        </div>
      ) : (
        !loading && (
          <div className="flex-1 flex items-center justify-center">
            <div className="text-center space-y-4">
              <h1 className="text-2xl font-medium text-gray-800">
               Loading...
              </h1>
              {/* <Link
                to={`/employer/${currentUser?.currentUser?._id}?tab=jobs`}
                className="inline-block bg-orange-500 text-white px-6 py-2 rounded-md hover:bg-orange-600 transition-colors duration-200"
              >
                Back
              </Link> */}
            </div>
          </div>
        )
      )}
    </div>
  );
}

export default ApplicantList;